import React from "react"
import type { FaqEntry } from "../../data/types"

type FAQBlockProps = {
  faq: FaqEntry[]
  heading?: string
}

export const FAQBlock = ({ faq, heading }: FAQBlockProps) => (
  <section className="text-gray-700 body-font">
    <div className="container mx-auto px-5 py-10">
      <div className="max-w-3xl">
        <h2 className="title-font text-2xl md:text-3xl font-medium text-gray-900 mb-6">
          {heading || "Perguntas frequentes"}
        </h2>
        <dl className="space-y-6">
          {faq.map((entry, idx) => (
            <div key={idx} className="border-l-4 border-purple-200 pl-4">
              <dt className="font-medium text-gray-900 mb-2">
                {entry.question}
              </dt>
              <dd className="text-gray-700 leading-relaxed">{entry.answer}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  </section>
)
